import axios from "axios";

const BASE_URL = "https://lms.childinfo.in/api";

export const getClasses = async (token) => {
  return axios.get(`${BASE_URL}/class.php`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getSubjects = async (token) => {
  return axios.get(`${BASE_URL}/subject.php`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
